export default "__VITE_ASSET__c3fc0097__"